import classes from "./History.module.scss";
import Image   from './../../Image/Image';

import img     from "../../Assets/Img/Src/HistoryGraph.jpg"
import imgWebp from "../../Assets/Img/Webp/HistoryGraph.webp"


const History = () => {
   return (
      <div className={classes.History}>
       <div className={classes.Wrapper}>
       <h3 className={classes.Title}>
          Историческая<br/> справка
       </h3>
       <div className={classes.Description}>
         <p className={classes.Text}>
           Работа над проектом ведётся уже более 5 лет.
           За это время был запущен новый сайт, менялись алгоритмы поисковых систем.
           Вслед за ними менялась наша стратегия.
        </p>
         <p className={classes.Text}>
              Вследствие этих изменений мы запустили группу лендингов по продуктовым линейкам:
          <br/><a href="http://topas.ru/" target="_blank" rel="noreferrer" className={classes.Link}>topas.ru</a>, <a href="https://xn----8sbah3bdubhwg.xn--p1ai/"  target="_blank" rel="noreferrer" className={classes.Link}>топлос-аква.рф</a>, <a href="https://ecopogreb.ru/" className={classes.Link}  target="_blank" rel="noreferrer">ecopogreb.ru</a>,
            которые внесли очень существенный вклад в общий трафик.
        </p>
         <p className={classes.Text}>
            Компания ТОПОЛ-ЭКО активно развивала социальные сети. Сменилось много сторонних подрядчиков и ответственных за сайт со стороны компании.
         </p>
       </div>
       <div className={classes.Start}>
          Например, лендинг <a href="http://topas.ru/" target="_blank" rel="noreferrer" >topas.ru</a>, после запуска и оптимизации показал следующие результаты:
       </div>
     </div>
      <div className={classes.Image}>
         <Image src={img} srcWebp={imgWebp}/>
       </div>
     </div>
   )
}
export default History;